module.exports = __webpack_public_path__ + "img/improvement.11da0da6.svg";